export const getAccessSelector = (state) => state.Profile.user.role?.access ?? [];

export const getRoleSelector = (state) => state.Profile.user.role;

export const isUserBoughtProjectSelector = (state) =>
  Number(state.Profile.user.investor_level) !== 0;

export const getUserLevelSelector = (state) => state.Profile.user.level;
